// extracted by mini-css-extract-plugin
export var bodySections = "_c4-8";
export var gray = "_c4-7";
export var green = "_c4-4";
export var iconContainer = "_c4-9";
export var iconWidgetContainer = "_c4-1";
export var phoneIcon = "_c4-2";
export var red = "_c4-5";
export var statusDot = "_c4-3";
export var widgetContainer = "_c4-0";
export var yellow = "_c4-6";